import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PendingApproval.css'; // We will create this css next

const PendingApproval = () => {
    const navigate = useNavigate();
    const status = localStorage.getItem('userStatus'); // Read status

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userStatus');
        navigate('/');
    };

    const isDisabled = status === 'disabled';

    return (
        <div className="pending-container">
            <div className="pending-card">
                <div className="icon-wrapper">
                    {isDisabled ? '🚫' : '⏳'}
                </div>
                <h2>{isDisabled ? 'الحساب موقوف' : 'الحساب قيد المراجعة'}</h2>

                {isDisabled ? (
                    <p>عذراً، تم إيقاف حسابك. يرجى التواصل مع الدعم الفني لمزيد من التفاصيل.</p>
                ) : (
                    <>
                        <p>شكراً لتسجيلك في منصة درس.</p>
                        <p>حسابك حالياً بانتظار موافقة الإدارة. ستصلك رسالة عبر البريد الإلكتروني عند تفعيل الحساب.</p>
                    </>
                )}

                <button className="logout-btn" onClick={handleLogout}>
                    تسجيل الخروج
                </button>
            </div>
        </div>
    );
};

export default PendingApproval;
